/**
 * Email HTML Serializer — converts email blocks + settings into
 * email-client-safe HTML with table layout and inline CSS.
 *
 * Supports: Gmail, Outlook, Apple Mail, Yahoo, Thunderbird
 * Uses: table layout, inline CSS, MSO conditionals, VML buttons
 */

const SOCIAL_ICONS = {
  linkedin: { color: '#0A66C2', label: 'LinkedIn', svg: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' },
  twitter: { color: '#1DA1F2', label: 'Twitter/X', svg: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' },
  facebook: { color: '#1877F2', label: 'Facebook', svg: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' },
  instagram: { color: '#E4405F', label: 'Instagram', svg: 'M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.882 0 1.441 1.441 0 012.882 0z' },
  youtube: { color: '#FF0000', label: 'YouTube', svg: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' },
  website: { color: '#1c1917', label: 'Website', svg: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' },
  tiktok: { color: '#000000', label: 'TikTok', svg: 'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z' },
};

function esc(str) {
  if (!str) return '';
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function renderSocialIcon(platform, url, size = '24', style = 'color') {
  const icon = SOCIAL_ICONS[platform];
  if (!icon || !url) return '';
  const fill = style === 'dark' ? '#1c1917' : style === 'light' ? '#ffffff' : icon.color;
  return `<a href="${esc(url)}" target="_blank" rel="noopener" title="${esc(icon.label)}" style="display:inline-block;margin:0 6px;text-decoration:none;">
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="${fill}"><path d="${icon.svg}"/></svg>
  </a>`;
}

function serializeBlock(block, settings) {
  const { block_type, props } = block;
  const maxW = settings.max_width || 600;

  switch (block_type) {
    case 'text':
      return `<tr><td style="padding:${props.padding || '16px 24px'};color:${props.text_color || '#1c1917'};background-color:${props.background_color || 'transparent'};font-size:${props.font_size || '14px'};line-height:${props.line_height || '1.6'};font-family:${settings.font_family || 'Arial, Helvetica, sans-serif'};">
        ${props.content || ''}
      </td></tr>`;

    case 'image': {
      if (!props.image_url) return `<tr><td style="padding:${props.padding || '8px 24px'};text-align:${props.alignment || 'center'};"><p style="color:#a8a29e;font-size:12px;">[Image placeholder]</p></td></tr>`;
      const align = props.alignment || 'center';
      const marginStyle = align === 'center' ? 'margin:0 auto;' : align === 'right' ? 'margin-left:auto;margin-right:0;' : 'margin-left:0;margin-right:auto;';
      const imgStyle = `width:${props.width || '100%'};max-width:100%;height:auto;display:block;border-radius:${props.border_radius || '0px'};${marginStyle}`;
      const img = `<img src="${esc(props.image_url)}" alt="${esc(props.alt_text)}" style="${imgStyle}" />`;
      const wrapped = props.link_url ? `<a href="${esc(props.link_url)}" target="_blank" style="text-decoration:none;display:block;${marginStyle}width:${props.width || '100%'};max-width:100%;">${img}</a>` : img;
      let html = `<tr><td style="padding:${props.padding || '8px 24px'};text-align:${align};">${wrapped}`;
      if (props.caption) html += `<p style="margin:8px 0 0;font-size:12px;color:#78716c;text-align:${align};">${esc(props.caption)}</p>`;
      return html + '</td></tr>';
    }

    case 'button': {
      const btnStyle = `display:inline-block;padding:${props.padding_y || '12px'} ${props.padding_x || '24px'};background-color:${props.bg_color || '#1c1917'};color:${props.text_color || '#ffffff'};text-decoration:none;border-radius:${props.border_radius || '6px'};font-size:${props.font_size || '14px'};font-weight:600;font-family:${settings.font_family || 'Arial, Helvetica, sans-serif'};mso-padding-alt:0;`;
      // VML fallback for Outlook
      const vml = `<!--[if mso]><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="${esc(props.href)}" style="height:auto;v-text-anchor:middle;width:${props.width === 'auto' ? '200px' : props.width};" arcsize="10%" strokecolor="${props.bg_color || '#1c1917'}" fillcolor="${props.bg_color || '#1c1917'}"><w:anchorlock/><center style="color:${props.text_color || '#ffffff'};font-size:${props.font_size || '14px'};font-weight:600;">${esc(props.text)}</center></v:roundrect><![endif]-->`;
      return `<tr><td style="padding:${props.outer_padding || '16px 24px'};text-align:${props.alignment || 'center'};">
        ${vml}
        <!--[if !mso]><!--><a href="${esc(props.href)}" target="_blank" style="${btnStyle}">${esc(props.text)}</a><!--<![endif]-->
      </td></tr>`;
    }

    case 'divider':
      return `<tr><td style="padding:${props.padding || '16px 24px'};">
        <table role="presentation" width="${props.width || '100%'}" cellpadding="0" cellspacing="0" border="0" style="margin:0 auto;"><tr><td style="border-top:${props.thickness || '1px'} solid ${props.color || '#d6d3d1'};font-size:1px;line-height:1px;">&nbsp;</td></tr></table>
      </td></tr>`;

    case 'spacer':
      return `<tr><td style="height:${props.height || '24px'};font-size:1px;line-height:1px;">&nbsp;</td></tr>`;

    case 'columns': {
      const count = props.column_count || 2;
      const ratios = (props.column_ratio || '50-50').split('-').map(Number);
      const gap = parseInt(props.gap) || 16;
      const cols = props.columns || [];
      let colHtml = '';
      for (let i = 0; i < count; i++) {
        const pct = ratios[i] || Math.floor(100 / count);
        const w = Math.floor((maxW - 48 - gap * (count - 1)) * pct / 100); // 48 = padding
        const colBlocks = cols[i]?.blocks || [];
        let inner = '';
        colBlocks.forEach(b => { inner += serializeBlock(b, settings); });
        if (!inner) inner = '<tr><td style="padding:8px;">&nbsp;</td></tr>';
        colHtml += `<td style="width:${pct}%;vertical-align:top;${i < count - 1 ? `padding-right:${gap}px;` : ''}">
          <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0">${inner}</table>
        </td>`;
      }
      return `<tr><td style="padding:${props.padding || '8px 24px'};">
        <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0"><tr>${colHtml}</tr></table>
      </td></tr>`;
    }

    case 'social': {
      const icons = (props.icons || []).filter(i => i.url);
      if (!icons.length) return '';
      const iconHtml = icons.map(i => renderSocialIcon(i.platform, i.url, parseInt(props.icon_size) || 24, props.icon_style)).join('');
      return `<tr><td style="padding:${props.padding || '16px 24px'};text-align:${props.alignment || 'center'};">
        ${iconHtml}
      </td></tr>`;
    }

    case 'header': {
      let inner = '';
      if (props.logo_url) {
        const logoAlign = props.logo_alignment || 'center';
        inner += `<img src="${esc(props.logo_url)}" alt="${esc(props.logo_alt || '')}" style="width:${props.logo_width || '150px'};max-width:100%;height:auto;display:block;${logoAlign === 'center' ? 'margin:0 auto;' : logoAlign === 'right' ? 'margin-left:auto;' : ''}" />`;
      }
      if (props.preheader_text) {
        inner += `<p style="margin:${props.logo_url ? '12px' : '0'} 0 0;font-size:12px;color:#78716c;text-align:center;">${esc(props.preheader_text)}</p>`;
      }
      return `<tr><td style="padding:${props.padding || '24px'};background-color:${props.background_color || '#ffffff'};">${inner}</td></tr>`;
    }

    case 'footer':
      return `<tr><td style="padding:${props.padding || '24px'};background-color:${props.background_color || '#f5f5f4'};text-align:center;font-size:${props.font_size || '11px'};color:${props.text_color || '#78716c'};line-height:1.6;font-family:${settings.font_family || 'Arial, Helvetica, sans-serif'};">
        ${props.company_name ? `<p style="margin:0 0 4px;font-weight:600;">${esc(props.company_name)}</p>` : ''}
        ${props.address ? `<p style="margin:0 0 8px;">${esc(props.address)}</p>` : ''}
        <p style="margin:0;"><a href="${esc(props.unsubscribe_url || '#')}" style="color:${props.text_color || '#78716c'};text-decoration:underline;">${esc(props.unsubscribe_text || 'Unsubscribe')}</a></p>
      </td></tr>`;

    case 'signature':
      return props.signature_html
        ? `<tr><td style="padding:${props.padding || '16px 24px'};">${props.signature_html}</td></tr>`
        : '';

    default:
      return `<tr><td style="padding:16px 24px;"><p style="color:#a8a29e;font-size:12px;">[Unknown block: ${block_type}]</p></td></tr>`;
  }
}

/**
 * Serialize an array of email blocks + settings into a complete email HTML document.
 *
 * @param {Object} settings - Email settings (max_width, background_color, etc.)
 * @param {Array} blocks - Array of block objects
 * @returns {string} Complete HTML email document
 */
export function serializeEmailHtml(settings, blocks) {
  const s = { ...settings };
  const maxW = s.max_width || 600;
  const bgColor = s.background_color || '#f5f5f4';
  const contentBg = s.content_background_color || '#ffffff';
  const fontFamily = s.font_family || 'Arial, Helvetica, sans-serif';

  // Preheader extraction from header block (hidden text for email preview)
  const headerBlock = blocks.find(b => b.block_type === 'header');
  const preheader = headerBlock?.props?.preheader_text || '';

  let bodyRows = '';
  blocks.forEach(block => {
    bodyRows += serializeBlock(block, s);
  });

  return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta name="x-apple-disable-message-reformatting" />
  <!--[if mso]><noscript><xml><o:OfficeDocumentSettings><o:AllowPNG/><o:PixelsPerInch>96</o:PixelsPerInch></o:OfficeDocumentSettings></xml></noscript><![endif]-->
  <style type="text/css">
    body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
    table { border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }
    p { margin: 0 0 12px; }
    a { color: #1c1917; }
    @media only screen and (max-width: 620px) {
      .email-container { width: 100% !important; max-width: 100% !important; }
      .email-container td { padding-left: 16px !important; padding-right: 16px !important; }
    }
  </style>
</head>
<body style="margin:0;padding:0;background-color:${bgColor};font-family:${fontFamily};">
  ${preheader ? `<div style="display:none;font-size:1px;color:${bgColor};line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">${esc(preheader)}</div>` : ''}
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:${bgColor};">
    <tr>
      <td align="center" style="padding:24px 0;">
        <!--[if mso]><table role="presentation" width="${maxW}" cellpadding="0" cellspacing="0" border="0"><tr><td><![endif]-->
        <table role="presentation" class="email-container" width="${maxW}" cellpadding="0" cellspacing="0" border="0" style="max-width:${maxW}px;width:100%;background-color:${contentBg};border-radius:4px;">
          ${bodyRows}
        </table>
        <!--[if mso]></td></tr></table><![endif]-->
      </td>
    </tr>
  </table>
</body>
</html>`;
}

/**
 * Extract plain text body from blocks (for text-only email fallback)
 */
export function extractPlainText(blocks) {
  return blocks.map(block => {
    if (block.block_type === 'text') {
      return (block.props.content || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    }
    if (block.block_type === 'button') return `[${block.props.text}](${block.props.href})`;
    if (block.block_type === 'footer') return `${block.props.company_name || ''}\n${block.props.address || ''}\n${block.props.unsubscribe_text || 'Unsubscribe'}`;
    return '';
  }).filter(Boolean).join('\n\n');
}
